export default (function (_ref) {
  var request = _ref.request;
  return {
    smartControlRuleAdd: function smartControlRuleAdd(data) {
      return request({
        url: '/iot/smartControlRule/add',
        method: 'post',
        data: data
      });
    },
    smartControlRuleModify: function smartControlRuleModify(data) {
      return request({
        url: "/iot/smartControlRule/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    smartControlRuleDel: function smartControlRuleDel(id) {
      return request({
        url: "/iot/smartControlRule/".concat(id, "/del"),
        method: 'delete'
      });
    },
    smartControlRuleQuery: function smartControlRuleQuery(data) {
      return request({
        url: '/iot/smartControlRule/query',
        method: 'get',
        params: data
      });
    },
    smartControlRuleDetail: function smartControlRuleDetail(id) {
      return request({
        url: "/iot/smartControlRule/".concat(id, "/detail"),
        method: 'get'
      });
    },
    smartControlRuleCache: function smartControlRuleCache(controlId) {
      return request({
        url: "/iot/smartControlRule/cache/".concat(controlId),
        method: 'get'
      });
    },
    smartControlRuleCacheClear: function smartControlRuleCacheClear(params) {
      return request({
        url: "/iot/smartControlRule/cache/clear",
        method: 'DELETE',
        params: params
      });
    }
  };
});